module.exports = __webpack_public_path__ + "assets/img/Earlytrade-Social-Static-Ad-w720.46095b97.webp";